export default function (Vue) {
  const VueFormatDecimalsFilter = (value, number) => {
    if (value || value === 0) {
      return parseFloat(value.toFixed(number))
    }
  }

  Vue.filter('formatDecimals', VueFormatDecimalsFilter)
}



// WEBPACK FOOTER //
// ./src/modules/filters/FormatDecimals.js